import 'src/decidim/posts/posts.js';

require.context('../images', true);

import 'entrypoints/decidim_posts.scss';
